/* eslint-disable no-console */
import { StateWeatherStation, WeatherStationData } from './definitions'
import apiService from '@/services/api'
import { extractDataFromStationData } from './helpers'
import { DateTime } from 'luxon'
import { createStore } from 'vue-reactive-store'

import { vrsStoreConfig } from '../config/store'
import Vue from 'vue'

const state: StateWeatherStation = {
  loading: false,
  loadingLatest: false,
  error: null,
  data: {},
  dataByTimestamp: {},
  latest: {}
}
const wsWorker = new Worker('@/worker/mfs.worker.ts', { type: 'module' })

const store = {
  name: 'weatherStation',
  state,
  actions: {
    async fetchWeatherStationDataLatestForOneStation (stationId: number) {
      store.state.loadingLatest = true
      try {
        const response = await apiService.getStationDataLatest(stationId)
        Vue.set(store.state.latest, stationId, extractDataFromStationData(
          response.data.WeatherData,
          stationId,
          vrsStoreConfig.state.data
        ))
      } catch (e) {
        console.error(e)
        store.state.error = e
      }
      store.state.loadingLatest = false
    },
    /**
     * Fetch latest data from weather stations
     *
     * @param {array} stations
     */
    async fetchWeatherStationDataLatest (stationsId: string[] = []) {
      store.state.loadingLatest = true
      try {
        const responseWeatherStationsDataLatest = await apiService.getStationsDataLatest(stationsId)
        Object.keys(responseWeatherStationsDataLatest).forEach(currentStationId => {
          const currentweatherStationDataLatest = responseWeatherStationsDataLatest[currentStationId]
          Vue.set(store.state.latest, currentStationId, extractDataFromStationData(
            currentweatherStationDataLatest.data.WeatherData,
            currentweatherStationDataLatest.station,
            vrsStoreConfig.state.data
          ))
        })
      } catch (e) {
        console.error(e)
        store.state.error = e
      }
      store.state.loadingLatest = false
    },

    /**
     * Fetch latest data from weather stations
     * for a given date
     *
     * @param {array} stations
     */
    async fetchWeatherStationDataLatestFilteredByDate (stationsId: string[], referenceDateLuxon: DateTime) {
      store.state.loadingLatest = true
      try {
        const responseWeatherStationsDataLatest = await apiService.getStationsDataFilteredByDate(
          stationsId,
          referenceDateLuxon.minus({ minutes: 60 }),
          referenceDateLuxon
        )
        Object.keys(responseWeatherStationsDataLatest).forEach(currentStationId => {
          const currentweatherStationDataLatest = responseWeatherStationsDataLatest[currentStationId]
          if (currentweatherStationDataLatest.length > 0) {
            Vue.set(store.state.latest, currentStationId, extractDataFromStationData(
              currentweatherStationDataLatest[0].data,
              currentweatherStationDataLatest[0].station,
              vrsStoreConfig.state.data
            ))
          }
        })
      } catch (e) {
        console.error(e)
        store.state.error = e
      }
      store.state.loadingLatest = false
    },

    /**
     * Fetch latest data from weather stations
     * for a given date
     *
     * @param {array} stations
     */
    async fetchWeatherStationDataFilteredByDate (stationsId: string[], from: DateTime, to: DateTime) {
      store.state.loading = true
      try {
        const responseWeatherStationsData = await apiService.getStationsDataFilteredByDate(stationsId, from, to)

        wsWorker.postMessage({
          type: 'config',
          data: vrsStoreConfig.state.data
        })
        wsWorker.postMessage({
          type: 'weatherstation',
          data: responseWeatherStationsData
        })
      } catch (e) {
        console.error(e)
        store.state.error = e
        store.state.loading = false
      }
    },

    resetState () {
      store.state.data = {}
      store.state.dataByTimestamp = {}
    }

  }
}

/**
 * Refresh state data after being processed by web worker.
 *
 * Used in fetchWeatherStationDataFilteredByDate
 *
 * If some stations already exist, refresh data for them, else push it
 */
wsWorker.onmessage = function (e: {
  data: {
    data: Record<string, WeatherStationData[]>;
    dataByTimestamp: Record<string, Record<string, WeatherStationData>>;
  };
}) {
  /**
   * We are not always retrieving all stations data,
   * we need to affect the right data from API to the right data in store,
   * data is indexed by station ids
   */
  Object.keys(e.data.data).forEach(currentStationId => {
    Vue.set(store.state.data, currentStationId, e.data.data[currentStationId])
  })
  Object.keys(e.data.dataByTimestamp).forEach(currentStationId => {
    Vue.set(store.state.dataByTimestamp, currentStationId, e.data.dataByTimestamp[currentStationId])
  })
  store.state.loading = false
}

export const fetchWeatherStationDataFilteredByDate = store.actions.fetchWeatherStationDataFilteredByDate

export const fetchWeatherStationDataLatestFilteredByDate = store.actions.fetchWeatherStationDataLatestFilteredByDate

export const fetchWeatherStationDataLatest = store.actions.fetchWeatherStationDataLatest

export const fetchWeatherStationDataLatestForOneStation = store.actions.fetchWeatherStationDataLatestForOneStation

export const vrsStoreWeatherStation = createStore(store)
